import * as types from '../types';
import { IGeocodingApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class GeocodingHttpApi extends HttpApi implements IGeocodingApi {
  async setPropertyLocation(
    propertyId: string,
    location: { latitude: number; longitude: number } | null
  ): Promise<types.PropertyLocation> {
    const body = location ?? { latitude: null, longitude: null };
    return (await this.http.put<types.APIResponse<types.PropertyLocation>>(`/properties/${propertyId}/location`, body)).data.data;
  }

  async requeuePropertyGeocode(propertyId: string): Promise<types.PropertyLocation> {
    return (await this.http.post<types.APIResponse<types.PropertyLocation>>(`/properties/${propertyId}/geocode`)).data.data;
  }

  async getGeocodingStatus(): Promise<types.GeocodingStatus> {
    return (await this.http.get<types.APIResponse<types.GeocodingStatus>>('/geocoding/status')).data.data;
  }

  async retryFailedGeocoding(): Promise<types.RetryFailedGeocodingResult> {
    return (await this.http.post<types.APIResponse<types.RetryFailedGeocodingResult>>('/geocoding/retry-failed')).data.data;
  }
}
